import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {AppRoutes, BannerTypes} from "../utils/constants";
import {Modal} from "react-bootstrap";
import Section from "./section";
import HelperService from "../services/helper-service";
import ModalCloseButton from "./modal-close-button";
import EventCell from "./event-cell";
import StarRating from "./star-rating";

export default function HomepageBannerCell({banner,  ...props}) {

    const [link, setLink] = useState(null);
    const [linkText, setLinkText] = useState(null);
    const [showDetailModal, setShowDetailModal] = useState(false);

    useEffect(() => {
        if (banner?.type){
            switch (banner.type){
                case BannerTypes.search:
                    setLink(`${AppRoutes.searchEvents.path}?keyword=${banner.term}&reset=true`);
                    setLinkText(`Search - "${banner.term}"`);
                    break;
                case BannerTypes.trainer:
                    // setLink(`${AppRoutes.trainers.path}/${banner?.trainers[0]?.id}`);
                    // setLinkText(`Go to detail`);
                    break;
                case BannerTypes.specificTraining:
                    // setLink(`${AppRoutes.events.path}/${banner?.events[0]?.id}`);
                    // setLinkText(`Go to detail`);
                    break;
                case BannerTypes.poster:
                    //setLink(AppRoutes.searchEvents.path);
                    break;
                default:
                    setLink(null);
                    setLinkText(null);
                    break;
            }
        } else {
            setLink(null);
        }
    }, [banner]);

    const BannerCell = function ({banner}) {
        return <div className="card border-0 overflow-hidden position-relative clickable" onClick={()=>setShowDetailModal(true)}>
            <h4>{banner.title}</h4>
            <p>{banner.subtitle}</p>
            <img alt='' src={banner.cover} className="img-fit w-100" style={{height: "720px", animation: "fadeIn 0.5s"}}/>
        </div>
    };

    const BannerTrainerCell = function({trainer, ...props}) {
        return (
            <Link to={`${AppRoutes.trainers.path}/${trainer?.id}`} className="clickable router-link">
                <div className="card px-3 py-4 mb-2 border-0 hover-cell-effect rounded-3">
                    <div className="d-flex flex-row gap-2 align-items-center">
                        <div className="rounded-circle bg-cover flex-shrink-0"
                             style={{backgroundImage: `url(${trainer?.photo})`, width: '70px', height: '70px'}}></div>
                        <div className="px-2 w-100" style={{minWidth: 0}}>
                            <h6 className="mb-1">{trainer?.name} {trainer?.surname}</h6>
                        </div>
                    </div>
                </div>
            </Link>
        );
    }



    const BannerEventCell = function({event, link, ...props}) {

        const TrainerCell = function ({trainer, ...props}) {
            return (<Link to={`${AppRoutes.trainers.path}/${trainer?.id}`} className="router-link" title={trainer?.name + ' ' + trainer?.surname}>
                <div className="clickable rounded-circle border-0 hover-cell-effect">
                    <div className="rounded-circle bg-cover" style={{backgroundImage: `url(${trainer?.photo})`, width: '65px', height: '65px'}}></div>
                </div>
            </Link>);
        }

        const TrainerBadge = function({trainer, subbed}){
            return <>
                {trainer &&
                    <div className="position-absolute z-3" style={{top: '5px', right: '5px'}}>
                        <TrainerCell trainer={trainer} />
                    </div>
                }
            </>
        }

        const PricingBadge = function({price, capacity}){
            let p = null;
            let t = null;

            if (price.nonMember!==null){
                p = price.nonMember===0 ? 'FREE' : price.nonMember;
                t = 'Walk-In';
            } else if (price.member!==null){
                p = price.member===0 ? 'FREE' : price.member;
                t = 'Member';
            }

            return <>{p && t && <div className="position-relative me-2 mt-2 p-2 rounded-2 d-inline-flex bg-secondary-subtle flex-column align-items-center">
                ${p}
                <span className="text-secondary fs-9 text-uppercase">{t}</span>
            </div>}</>
        }

        const PopupBadge = function({popup}){
            return <>{popup && <div className="position-relative me-2 mt-2 p-2 rounded-2 d-inline-flex bg-secondary-subtle flex-column align-items-center fs-8 text-uppercase">Pop-Up | Special event</div>}</>
        }

        return (
            <div className="card mb-4 d-flex flex-row rounded-3 hover-cell-effect position-relative">
                <div className="card-body position-relative">
                    <TrainerBadge trainer={event?.trainer} subbed={event?.events[0]?.subbed}/>
                    <h6>{event?.course?.name}</h6>
                    <div
                        className="text-secondary fs-7 mb-1">{HelperService.getNiceDateString(event?.events[0]?.datetime, event?.events[0]?.timezone)} {HelperService.getEventOffsetString(event?.events[0]?.datetime, event?.events[0]?.timezone)}</div>
                    <div className="text-secondary fs-7"><span
                        className="mdi mdi-map-marker-outline"></span> {event?.place?.name}{HelperService.getDistance(event?.place?.location) ? `, (${HelperService.getDistance(event?.place?.location)} mi)` : ''}
                    </div>
                    {event?.place?.location && <div
                        className="text-secondary fs-7">{event.place.location.city && event.place.location.state ? `${event.place.location.city}, ${event.place.location.state}` : event.place.location.address}</div>}
                    <PricingBadge price={event?.events[0]?.price} capacity={event?.events[0]?.capacity}/>
                    <PopupBadge popup={event?.events[0]?.special}/>
                </div>
                {link && <Link className="text-decoration-none stretched-link" to={link}></Link>}
            </div>
        );
    }

    const DetailModal = function () {
        const closeModal = () => setShowDetailModal(false);

        return <Modal size='xl' show={!!showDetailModal} onHide={closeModal} centered>
            <Modal.Body className="p-5">
                <ModalCloseButton close={closeModal}/>
                {banner.cover && <Section animation={HelperService.getRandomAnimation()}>
                    {banner.video &&
                        <div className={'card rounded-3 overflow-hidden mb-3'}>
                            <video width="100%" poster={banner.cover} controls>
                                <source src={banner.video} type="video/mp4"/>
                            </video>
                        </div>
                    }
                    {!banner.video &&
                        <div className={'card rounded-3 overflow-hidden mb-3'}>
                            <img src={banner.cover} alt="" className="img-fit"/>
                        </div>
                    }
                </Section>}
                <Section animation={HelperService.getRandomAnimation()}>
                    <div className="row pb-3">
                        <div className="col-sm-12 mb-3">
                            <h4>{banner.title}</h4>
                            <h5>{banner.subtitle}</h5>
                            <p className="text-dark" dangerouslySetInnerHTML={{__html: banner.content.replace(/\n/g, '<br />')}}></p>

                            {banner.type === BannerTypes.trainer && banner?.trainers?.length > 0 &&
                                <div className="row">
                                    {banner.trainers.map((trainer) => {
                                        return <div key={trainer?.id} className="col-sm-6"><BannerTrainerCell trainer={trainer}/></div>
                                    })}
                                </div>
                            }

                            {banner.type===BannerTypes.specificTraining && banner?.events.length > 0 &&
                                <div className="row">{banner.events.map((t)=>{
                                        t.events = [{...t}];
                                        return <div key={t.id} className="col-sm-12 col-md-6"><BannerEventCell event={t} link={`${AppRoutes.events.path}/${t.id}`} /></div>
                                    })}
                                </div>
                            }

                            {link && <Link className="btn btn-primary" to={link}>{linkText}</Link>}
                        </div>
                    </div>
                </Section>
            </Modal.Body>
        </Modal>
    };

    return (<>
        <BannerCell banner={banner} />
        {showDetailModal && <DetailModal />}
    </>);
}
